/** Services an organization only has when switched on. Mirrors platform-backend's OptionalService. */
export enum OptionalService {
  CAMPAIGNS = "campaigns",
  CATALOGS = "catalogs",
  DATA_HUB = "data_hub",
  META_AGENT = "meta_agent"
}

export const OPTIONAL_SERVICES: { value: OptionalService; label: string; description: string }[] = [
  {
    value: OptionalService.CAMPAIGNS,
    label: "Campaigns",
    description: "Bulk template messages to audiences"
  },
  {
    value: OptionalService.CATALOGS,
    label: "Catalogue",
    description: "Product catalogs, the catalog bot node and orders"
  },
  {
    value: OptionalService.DATA_HUB,
    label: "Data Hub",
    description: "Custom tables. Orders and tickets keep working without it"
  },
  {
    value: OptionalService.META_AGENT,
    label: "Meta Business Agent",
    description: "Meta's AI agent on WhatsApp numbers"
  }
];

/** `null` = unlimited. */
export interface PlanLimits {
  teams: number | null;
  channels: number | null;
  aiTokensPerMonth: number | null;
}

export interface PlanSettings {
  enabledServices: OptionalService[];
  limits: PlanLimits;
}

/** A preset. Applying it copies its values onto an organization. */
export interface Package extends PlanSettings {
  key: string;
  name: string;
  order: number;
}

export interface OrganizationPlan extends PlanSettings {
  /** The package last applied, as a label; null = custom. */
  package: string | null;
  /** From before packages: keeps Campaigns, Catalogue and Data Hub, no limits. */
  legacy: boolean;
}
